import { Link } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { brandServiceCategories } from './categories';
import styles from './ServicesIndex.module.css';

/**
 * /services index — a grid of category cards, each linking to its own landing
 * page. Replaces the filter dashboard at the root services route.
 *
 * Uses brandServiceCategories() so the brand allowlist + coming-soon filter
 * are respected (same source as sidebar nav).
 */
export default function ServicesIndex() {
  const categories = brandServiceCategories();

  return (
    <Container size="xl">
      <PageHeader
        icon={<LayoutGrid size={22} />}
        eyebrow="Services"
        title="All services"
        description="Browse the platform's service categories."
      />
      <div className={styles.grid}>
        {categories.map((cat) => {
          const Icon = cat.icon;
          const href = cat.landingRoute ?? `/services?category=${cat.key}`;
          return (
            <Link key={cat.key} to={href} className={styles.card}>
              <span className={styles.iconWrap}>
                <Icon size={22} />
              </span>
              <div className={styles.body}>
                <div className={styles.title}>{cat.title}</div>
                <div className={styles.desc}>{cat.description}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </Container>
  );
}
